import { COMPONENTS } from '../../../components/components.registry';
import { RedirectionsSuggestionsConfig } from '../../../models';

export const DEFAULT_REDIRECTIONS_SUGGESTIONS_CONFIG: RedirectionsSuggestionsConfig = {
  components: {
    container: COMPONENTS.PURE.Suggestions,
    item: COMPONENTS.PURE.RedirectionSuggestion,
    icon: null,
    header: null
  },
  size: 5
};
